import {
  persistStore,
  persistReducer
} from 'redux-persist'
import localforage from 'localforage'
import { configureStore, combineReducers } from '@reduxjs/toolkit'
import { we_api } from '../services/services';

import { baseReducer } from '../reducers/baseReducer';
import { messageReducer } from '../reducers/messageReducer';
import { personDataReducer } from '../reducers/personDataReducer';
import { staticDataReducer } from '../reducers/staticDataReducer';
import { tierReducer } from '../reducers/tierReducer';
import { userReducer } from '../reducers/userReducer';

const rootReducer = combineReducers({
  base: baseReducer,
  message: messageReducer,
  personData: personDataReducer,
  staticData: staticDataReducer,
  tier: tierReducer,
  user: userReducer,
  [we_api.reducerPath]: we_api.reducer,
})

const persistConfig = {
  key: 'root',
  storage: localforage
};

const persistedReducer = persistReducer(persistConfig, rootReducer)

// Automatically adds the thunk middleware and the Redux DevTools extension
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
    immutableCheck: false
  }).concat(we_api.middleware),
  devTools: {
    autoPause: true,
    shouldRecordChanges: false,
    maxAge: 15,
    trace: false
  }
});

const persistor = persistStore(store);

export { persistor, store };